import React, { useMemo, useState, useEffect } from 'react';
import { Modal, Tabs, Row, Col } from 'antd';
import NoDataEmpty from './../noDataEmpty';
import './productModal.less';
const { TabPane } = Tabs;

const ProductModal = (props) => {
    const { productList, productModalVisible, selectProductData, productData } = props;
    const [activetData, setActivetData] = useState(undefined);
    const handleOk = () => {
        productData(activetData);
        props.productHandleCancel(activetData);
    };
    useEffect(() => {
        setActivetData(selectProductData);
    }, [selectProductData]);
    const handleCancel = () => {
        setActivetData(selectProductData);
        props.productHandleCancel();
    };
    const selectServe = (item) => {
        if (activetData && activetData.id === item.id) {
            return;
        }
        setActivetData(item);
    };
    // 获取周期类型
    const getCycle = (type) => {
        switch (type) {
            case 1:
                return '天';
            case 2:
                return '周';
            case 3:
                return '月';
            default:
                return '';
        }
    };


    // 频次性
    const frequencyList = (data) => {
        return (
            data.map((item) => {
                return (
                    <li
                        className={activetData && activetData.id === item.id ? 'active' : ''}
                        key={item.id}
                        onClick={() => selectServe(item)}
                    >
                        <Row>
                            <Col span={17}>
                                <p>{item.productName}</p>
                                {item.validityDate && <span>有效期至{item.validityDate}</span>}
                            </Col>
                            <Col span={1} />
                            <Col span={6}>
                                <span>剩余次数：<a>{item.remainNum}</a>/{item.serviceNum}</span>
                            </Col>
                        </Row>
                        {activetData && activetData.id === item.id && (
                            <img
                                className="pitchImg"
                                src={require('./../../assets/images/pitchOn.png')} />
                        )}

                    </li>
                );
            })
        );
    };
    // 周期性
    const periodList = (data) => {
        return (
            data.map((item) => {
                return (
                    <li
                        className={activetData && activetData.id === item.id ? 'active' : ''}
                        key={item.id}
                        onClick={() => selectServe(item)}
                    >
                        <Row>
                            <Col span={17}>
                                <p>{item.productName}</p>
                                {item.validityDate && <span>有效期至{item.validityDate}</span>}
                            </Col>
                            <Col span={1} />
                            <Col span={6}>
                                <span>本{getCycle(item.cycleType)}剩余次数：<a>{item.remainNum}</a>/{item.serviceNum}</span>
                                <div className="reset">
                                    <img src={require('./../../assets/images/plaint.png')} />
                                    <i>{item.remainDay}天后将重置次数</i>
                                </div>
                            </Col>
                        </Row>
                        {activetData && activetData.id === item.id && (
                            <img
                                className="pitchImg"
                                src={require('./../../assets/images/pitchOn.png')} />
                        )}
                    </li>
                );
            })
        );
    };

    return useMemo(() => (
        <Modal
            cancelText={'取消'}
            className="modalStyle"
            okButtonProps={{ disabled: !activetData || activetData.remainNum === 0 }}
            okText={'确定'}
            onCancel={handleCancel}
            onOk={handleOk}
            title="选择产品"
            visible={productModalVisible}
            width={720}
        >
            <Tabs
                className="tabsStyle"
                defaultActiveKey="1"
            >
                <TabPane
                    key="1"
                    tab={`周期性产品(${productList.cycleNum})`}
                >
                    <ul>
                        {productList.cycleNum === 0 ? (
                            <NoDataEmpty
                                distance={80}
                                text={'暂无产品'} />
                        ) : periodList(productList.cycleData)}
                    </ul>
                </TabPane>
                <TabPane
                    key="2"
                    tab={`频次性产品(${productList.noCycleNum})`}

                >
                    <ul>
                        {productList.noCycleNum === 0 ? (
                            <NoDataEmpty
                                distance={80}
                                text={'暂无产品'} />
                        ) : frequencyList(productList.noCycleData)}
                    </ul>

                </TabPane>
            </Tabs>
        </Modal>
    ), [productList, productModalVisible, activetData]);
};

export default ProductModal;